/**
 * Timeout View
 */

define(function(require) {
    'use strict';

    var BaseView = require('common/base.view');
    var _ = require('underscore');
    var Form = require('class/form.class');
    var TimeoutModel = require('portlets/responsible-gaming/timeout/timeout.model');

    return BaseView.extend({

        events: {
            'submit .fn-form-timeout': 'sendTimeout'
        },

        render: function() {
            this.$el.html(this.tmpl('timeout'));

            this.model = new TimeoutModel();
            this.model.fetch()
                .done(this.renderPage.bind(this))
                .fail(this.renderNetworkError.bind(this));

            return this;
        },

        renderPage: function() {
            var templateData = {
                availablePeriods: this.model.get('availablePeriods')
            };
            var activeTimeout = _.findWhere(this.model.get('timeouts'), {state: 'ACTIVE'});
            if (activeTimeout) {
                _.extend(templateData, {
                    active: true,
                    endDate: activeTimeout.endTime
                });
            }
            this.$el.html(this.tmpl('timeout', templateData));
            var $form = this.$('.fn-form-timeout');
            if (!$form.length) {
                return;
            }
            this.form = new Form($form, {
                validationConfig: {
                    timeout: {
                        required: true
                    }
                }
            });
        },

        sendTimeout: function(e) {
            e.preventDefault();

            this.form.validate().done(function() {
                this.form.showLoading();
                this.model
                    .save({
                        timeoutPeriod: this.form.data('timeout')
                    })
                    .always(this.form.hideLoading.bind(this.form))
                    .done(this.success.bind(this))
                    .fail(this.error.bind(this));
            }.bind(this));
        },

        success: function() {
            window.Playtech.API.popup.showPopup({
                content: this.translate('playtech.mobile.ngresponsiblegaming.timeout.sucess')
            });

            this.render();
        },

        error: function(response) {
            if (response.data.errorMessage === 'rg_timeout_exists') {
                this.form.showErrorMessages({
                    content: this.translate('playtech.mobile.ngresponsiblegaming.timeout.timeoutset',
                        this.translate('playtech.mobile.ngresponsiblegaming.timer.' + this.model.get('timeoutPeriod'))
                        )
                });
            } else {
                this.form.showErrorMessages({
                    content: response.data.errorMessage
                });
            }
        }

    });
});

